<template>
  <b-row class="mt-4">
    <b-col>
      <GoogleLogin :login="isLogin" @click="googleLogin" />
    </b-col>
    <b-col>
      <FacebookLogin :login="isLogin" @click="facebookLogin" />
    </b-col>
  </b-row>
</template>

<script>
import GoogleLogin from 'UI/Login/Google';
import FacebookLogin from 'UI/Login/Facebook';
export default {
  components: {
    GoogleLogin,
    FacebookLogin
  },
  props: {
    isLogin: {
      type: Boolean,
      deafult: true
    }
  },
  mounted() {
    window.fbAsyncInit = function () {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: '308868272535767',
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v10.0'
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  },
  methods: {
    googleLogin() {
      this.$emit('login');
      this.$auth.loginWith('google');
      this.$store.dispatch('updateUserDataIntercom');
    },
    facebookLogin() {
      this.$emit('login');
      this.$auth.loginWith('facebook');
      this.$store.dispatch('updateUserDataIntercom');
    }
  }
};
</script>
